<template>
  <pt-notice-detail class="pt-notice-detail__withData" :id="id" :noticeDetail="noticeDetail"></pt-notice-detail>
</template>

<script>
import PtNoticeDetail from './index'
export default {
  name: 'pt-notice-detail__withData',
  components: {
    'pt-notice-detail': PtNoticeDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      noticeDetail: {}
    }
  },
  methods: {
    getNoticeDetail () {
      this.$store.dispatch('noticeDetail', this.id).then(res => {
        this.noticeDetail = res
      }).catch(err => {
        this.$message.error(err || '获取消息详情失败')
      })
    }
  },
  created () {
    this.getNoticeDetail()
  }
}
</script>
